module.exports = __webpack_public_path__ + "04_hair_silver.b5f7c0f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/04_hair_silver.png
// module id = 5wmr
// module chunks = 0